import { FC, PropsWithChildren, useEffect } from 'react'

import isPropValid from '@emotion/is-prop-valid'
import { StyleSheetManager, ThemeProvider } from 'styled-components'

import { themeColors } from 'src/Styled/variables'
import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import {
  getThemeMode,
  getResolvedTheme,
  setOsTheme,
} from 'src/Redux/theme-process'
import { getOSTheme, subscribeToOSThemeChanges } from 'src/Utils/getOSTheme'

import { GlobalStyles } from './GlobalStyles/index'

export const StyleSheetManagerWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const dispatch = useAppDispatch()
  const themeMode = useAppSelector(getThemeMode)
  const resolvedTheme = useAppSelector(getResolvedTheme)

  useEffect(() => {
    if (themeMode !== 'auto') {
      return void 0
    }

    dispatch(setOsTheme(getOSTheme()))

    return subscribeToOSThemeChanges((newTheme) => {
      dispatch(setOsTheme(newTheme))
    })
  }, [themeMode, dispatch])

  return (
    <ThemeProvider theme={themeColors[resolvedTheme]}>
      <GlobalStyles />
      <StyleSheetManager shouldForwardProp={shouldForwardProp}>
        {children}
      </StyleSheetManager>
    </ThemeProvider>
  )
}
// This implements the default behavior from styled-components v5
function shouldForwardProp(propName: string, target: unknown): boolean {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName)
  }
  // For other elements, forward all props
  return true
}
